import saveAs from 'file-saver';
import $ from 'jquery';
import { getAllComponents } from '../../Events/CreateRulesPerPage';
import { apiService, generatePageJs } from '../../../../services';

const changeMethodName = (methodsTobChangeKeys) =>
  methodsTobChangeKeys.reduce(
    (renamedObject, method) => ({ ...renamedObject, [method.methodName]: { ...method } }),
    {}
);

const findService = (annotationName) => {

  const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
  const projectAnns = JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0].combinations;  
  const serviceAnnMethod = projectAnns.filter( (ann) => ann.annotationName === annotationName && ann.method === `service${ann.annotationLink}`).map(ann => ann);

  return serviceAnnMethod.length > 0;

}

const serviceEntity = (entity) => {

  const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
  const projectAnns = JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0].combinations;  
  const serviceAttrs = projectAnns.filter((ann) => ann.annotationLink === entity && ann.attributeType === 'service').map( ann => ann);

  return serviceAttrs.length > 0;
}

const convertBodyToHtmlCode = (code, pageName) => {
  let foundDatepicker = false;
  if (code.includes('id="datepicker') === true) {
    foundDatepicker = true;
  }

  const headCode =
    `<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"/>
    <link rel="stylesheet" type="text/css" href="../css/${pageName}.css">
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous">
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.4.0/font/bootstrap-icons.css">
    <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
    ${(foundDatepicker === true
      ? `<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/css/bootstrap-datepicker.min.css" integrity="sha512-mSYUmp1HYZDFaVKK//63EcZq4iFWFjxSL+Z3T/aCt4IO9Cejm03q3NKKYN6pFQzY0SBOr8h+eCIAZHPXcpZaNw==" crossorigin="anonymous" referrerpolicy="no-referrer" />
        <script src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/js/bootstrap-datepicker.min.js" integrity="sha512-T/tUfKSV1bihCnd+MxKD0Hm1uBBroVYBOYSk1knyvQ9VyZJpc/ALb4P0r6ubwVPSGB2GvjeoMAJJImBG12TiaQ==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>`
      : ``)}
    <title>${pageName} </title>
    </head>`;

  const bodyCode =
    `<body onunload="">${code}
    <script src="../dist/${pageName}.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js" integrity="sha384-ApNbgh9B+Y1QKtv3Rn7W3mgPxhU9K/ScQsAP7hUibX39j7fakFPskvXusvfa0b4Q" crossorigin="anonymous"></script>
    <script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js" integrity="sha384-JZR6Spejh4U02d8jOt6vLEHfe/JQGiRRSQQxSfFWpi1MquVdAyjUar5+76PVCmYl" crossorigin="anonymous"></script>
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js" integrity="sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM" crossorigin="anonymous"></script>
    </body>`;

  const htmlCode = `<!DOCTYPE HTML><html>${headCode}${bodyCode}</html>`;

  return htmlCode;
};

const convertIdToName = (id) => {
  let name = '';
  const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));

  JSON.parse(localStorage.getItem('data'))[selectedProject].pages.forEach((page) => {
    if (page.pageId === id) {
      name = page.name;
    }
  });
  return name;
};

const createBackHistoryCommand = (compId ) => {
  const functionToBeAddedName = `backHistoryNavigation`;
  const functionality = '{ history.back(); }';
  const methodType = 'ChangeURLFunction';
  const inputDataTemplate = '<params>';

  return {
    functionName: functionToBeAddedName,
    functionality,
    compIds: [compId],
    inputDataTemplate,
    methodType,
    transitionById: false
  };
}

const recreatePageTransitionCommand = (targetPage, compId, openWindow, existsTransitionById) => {
  const functionToBeAddedName = `navigateTo${targetPage}`;
  const functionality =
    openWindow === false
      ? `{ <sessionStorageParams> <findId> location.href= '/${targetPage}<params>' <assignId>;}`
      : `{ <sessionStorageParams> <findId> window.open('/${targetPage}<params>' <assignId>,"_blank", 'width=600, height=600, location=yes');}`;
  const methodType = 'ChangeURLFunction';
  const inputDataTemplate = '<params>';

  return {
    functionName: functionToBeAddedName,
    functionality,
    compIds: [compId],
    inputDataTemplate,
    methodType,
    transitionById: existsTransitionById
  };
};

const createFileEventListener = (compId) => {
  const inputDataTemplate = '<params>';
  const methodType = 'FileEventListener';

  return {
    methodType,
    inputDataTemplate,
    compIds: [compId]
  };
};

const createDatepickerMethod = (compId) => {
  const methodType = 'DatePickerMethod';

  return {
    compIds: [compId],
    methodType
  };
};

const createHrefTransitionCommand = (href, compId, openWindow) => {
  const functionToBeAddedName = `navigateTo${href}`;
  const functionality =
    openWindow === false
      ? `{ window.document.location = '${href}';}`
      : `{ window.open('${href}',"_blank", 'width=600, height=600, location=yes');}`;
  const methodType = 'ChangeURLFunction';
  const inputDataTemplate = '<params>';

  return {
    functionName: functionToBeAddedName,
    functionality,
    compIds: [compId],
    inputDataTemplate,
    methodType
  };
};

const createServiceFunction = (annotationName, compId) => {

  const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
  const serviceName = JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0].combinations.filter( ann => ann.annotationName === annotationName).map( ann => ann.attributeTypeService)[0];
  const service = JSON.parse(localStorage.getItem('data'))[selectedProject].services[0].services_requests.filter( serv => serv.name === serviceName).map(serv => serv)[0];
  const selectedAnnotation = JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0].combinations.filter( comb => comb.annotationName === annotationName).map(comb => comb)[0];
  let headers = [];
  let query_par = [];
  let body_par = [];

  if(selectedAnnotation.serviceParams !== undefined && selectedAnnotation.serviceParams.headers !== null){
    headers = selectedAnnotation.serviceParams.headers;
    body_par = selectedAnnotation.serviceParams.bodyParams;
    query_par = selectedAnnotation.serviceParams.queryParams;
  }
  else{
    headers = service.headers;
    body_par = service.body_par;
    query_par = service.query_par;
  }

  const methodType = 'Service';
  const { typeRequest } = service;

  return{
    methodType,
    body_par,
    headers,
    query_par,
    url: service.url,
    service_name: service.name,
    typeRequest,
    compId
  }

}

const createJavascriptPerComp = async (comp, methodName, functionEntities) => {
  const commands = [];
  const compId = comp.attributes.attributes.id;
  const annotationName = comp.attributes.attributes.annotationname;
  const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
  let method = methodName;
  let ent = '';

  if (
    comp.attributes.attributes.target_page !== undefined 
  ) {
    const existsOpenWindow = comp.attributes.attributes['open-window'] === true;
    const existsTransitionById = comp.attributes.attributes['transition-by-id'] === true;
    commands.push(
      recreatePageTransitionCommand(
        convertIdToName(comp.attributes.attributes.target_page),
        compId,
        existsOpenWindow,
        existsTransitionById
      )
    );
  }

  if(comp.attributes.attributes['back-button'] !== undefined){
    commands.push(createBackHistoryCommand(compId));
  }

  if (comp.attributes.attributes.type !== undefined && comp.attributes.attributes.type === 'file') {
    commands.push(createFileEventListener(compId));
  }

  if (
    comp.attributes.attributes.arrayinput !== undefined &&
    comp.attributes.attributes.arrayinput === 'true'
  ) {
    commands.push({
      functionName: 'InputArray',
      functionality: '',
      compIds: [compId],
      inputDataTemplate: '',
      methodType: 'ComplexInput'
    });
  }

  if (
    comp.attributes.attributes['advance-select'] !== undefined &&
    comp.attributes.attributes['advance-select'] === true
  ) {
    commands.push({
      functionName: 'alignSelectOptionEvent',
      functionality: '',
      compIds: [compId],
      inputDataTemplate: '',
      methodType: 'SelectAlignEvent'
    });
  }

  if (
    comp.attributes.attributes.id !== undefined &&
    String(comp.attributes.attributes.id).startsWith('datepicker') === true
  ) {
    commands.push(createDatepickerMethod(compId));
  }

  const { href } = comp.attributes.attributes;
  if (href !== undefined && href !== '#' && href !== '#!') {
    if (comp.attributes.attributes['open-window'] === true) {
      commands.push(createHrefTransitionCommand(href, compId, true));
    } else {
      commands.push(createHrefTransitionCommand(href, compId, false));
    }
  }

  if(annotationName !== undefined) {
    if(findService(annotationName) === true){
      commands.push(createServiceFunction(annotationName, compId));
      return commands;
    }
  }

  if (annotationName !== undefined) {
    const { annotations } = JSON.parse(localStorage.getItem('data'))[selectedProject];
    let foundMethod = false;
    annotations[0].combinations.forEach((comb) => {
      if (comb.annotationName === annotationName && comb.method !== 'none') {
        method = comb.method;
        foundMethod = true;
        ent = comb.annotationLink;
      }
    });
    if (foundMethod === true && method !== 'none' && ent !== '') {
      const selectedPage = localStorage.getItem('selectedPage');
      const pageName = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage]
        .name;
      let command = { functionName: '', functionality: '', compIds: [compId] };
      if (
        method !== 'none' &&
        functionEntities !== undefined &&
        functionEntities[ent] !== undefined && 
        functionEntities[ent][method] !== undefined
      ) {
        command.functionName = method;
        command.annotationName = annotationName;
        command.entityName = ent;
        command = { ...command, ...functionEntities[ent][method], pageName };
      }

      commands.push(command);
      
    }
  } 
  return commands;
  
};

const addFunctionToJavascript = (commands, indexPage, editor) => {
  const selectedPage = indexPage !== undefined ? indexPage : JSON.parse(localStorage.getItem('selectedPage'));
  const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
  const projectsData = JSON.parse(localStorage.getItem('data'));

  projectsData[selectedProject].pages[selectedPage].javascript.functions = [];
  projectsData[selectedProject].pages[selectedPage].javascript.changeJavascript = false;
  projectsData[selectedProject].pages[selectedPage].javascript.imports = [];

  commands.forEach((command) => {
    command.forEach((insCommand) => {
      let compId = '';
      try {
        [compId] = insCommand.compIds;
      } catch (error) {
        compId = '';
      }
      const serviceFunc = projectsData[selectedProject].pages[selectedPage].javascript.functions.filter( func => func.service_name === insCommand.service_name).map( func => func);
      if(insCommand.methodType !== 'Service' ){
        projectsData[selectedProject].pages[selectedPage].javascript.functions.push({
          ...insCommand,
          compId
        });
      }
      else if( serviceFunc.length === 0 ){
          projectsData[selectedProject].pages[selectedPage].javascript.functions.push({
            ...insCommand,
          });
      }
      else{
        projectsData[selectedProject].pages[selectedPage].javascript.functions.forEach( (func, funcId) => {
          if(func.service_name === insCommand.service_name){
            projectsData[selectedProject].pages[selectedPage].javascript.functions[funcId].ids.push(insCommand.ids[0]);
            projectsData[selectedProject].pages[selectedPage].javascript.functions[funcId].selected_inputs.push(insCommand.selected_inputs[0]);
          }
        })
      }
    });
  });

  const doc = new DOMParser().parseFromString( (editor !== undefined ? editor.getHtml() : projectsData[selectedProject].pages[selectedPage].html ), 'text/html');

  projectsData[selectedProject].pages[selectedPage].javascript.file = generatePageJs(
    projectsData[selectedProject].pages[selectedPage].javascript.functions,
    projectsData[selectedProject].annotations,
    doc,
    projectsData[selectedProject].pages[selectedPage].javascript.customFunctions || [],
    projectsData[selectedProject].services || []
  );

  localStorage.setItem('data', JSON.stringify(projectsData));
};

const exportCode = (editor, setLoadSpinnerCreateJavascript) => {
  function exportHtml() {
    const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
    const selectedPage = JSON.parse(localStorage.getItem('selectedPage'));
    const pageName = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage]
      .name;

    const filename = `HTMLContent${pageName}.html`;
    const content = convertBodyToHtmlCode(editor.getHtml(), pageName);
    const blob = new Blob([content], {
      type: 'text/plain;charset=utf-8'
    });

    saveAs(blob, filename);
  }

  function exportCss() {
    const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
    const selectedPage = JSON.parse(localStorage.getItem('selectedPage'));
    const pageName = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage]
      .name;

    const filename = `CSSContent${pageName}.css`;
    const content = editor.getCss();
    const blob = new Blob([content], {
      type: 'text/plain;charset=utf-8'
    });

    saveAs(blob, filename);
  }

  function exportJavascript() {
    const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
    const selectedPage = JSON.parse(localStorage.getItem('selectedPage'));
    const javascriptContent = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[
      selectedPage
    ].javascript.file;
    const pageName = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage]
      .name;

    const filename = `JavascriptContent${pageName}.js`;

    const blob = new Blob([javascriptContent], {
      type: 'text/plain;charset=utf-8'
    });

    saveAs(blob, filename);
  }

  editor.Commands.add('export2', {
    run(editorGrapes, sender = {}) {
      if(sender && sender.set){
        sender.set('active', 0);
      }
      const config = editor.getConfig();
      const modal = editor.Modal;
      const pfx = config.stylePrefix;
      this.cm = editor.CodeManager || null;

      if (!this.$editors) {
        const oHtmlEd = this.buildEditor('htmlmixed', 'hopscotch', 'HTML');
        const oCsslEd = this.buildEditor('css', 'hopscotch', 'CSS');
        const oJavascriptlEd = this.buildEditor('javascript', 'hopscotch', 'Javascript');
        this.htmlEditor = oHtmlEd.el;
        this.cssEditor = oCsslEd.el;
        this.javascriptEditor = oJavascriptlEd.el;
        const $editors = $(`<div class="${pfx}export-dl"></div>`);

        const rowButtons = $(`<div> <div>`);
        rowButtons.addClass(['rowButtonStyle']);
        const exportHtmlButton = $(
          `<button class="gjs-btn-prim gjs-btn-import buttonExportStyle">Export page HTML</button>`
        );
        $(exportHtmlButton).on('click',  () => {
          exportHtml();
        });

        const exportCssButton = $(
          `<button class="gjs-btn-prim gjs-btn-import buttonExportStyle" id='cssButton'> Export page CSS</button>`
        );
        $(exportCssButton).on('click', exportCss);

        const exportJavscriptButton = $(
          `<button class="gjs-btn-prim gjs-btn-import buttonExportStyle" id='javascriptButton'> Export page Javascript</button>`
        );
        $(exportJavscriptButton).on('click', exportJavascript);

        $(exportCssButton).appendTo($(rowButtons));
        $(exportHtmlButton).appendTo($(rowButtons));
        $(exportJavscriptButton).appendTo($(rowButtons));

        $editors
          .append(oHtmlEd.$el)
          .append(oCsslEd.$el)
          .append(oJavascriptlEd.$el)
          .append(rowButtons);

        this.$editors = $editors;
      }

      modal
        .open({
          title: config.textViewCode,
          content: this.$editors
        })
        .getModel()
        .once('change:open', () => editor.stopCommand(this.id));

      const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
      const selectedPage = JSON.parse(localStorage.getItem('selectedPage'));
      const pageName = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage].name;
      const entitieNames = JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0] !== undefined ? JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0].entities : [];
      const projectId = JSON.parse(localStorage.getItem('data'))[selectedProject]._id;

      const newCode = convertBodyToHtmlCode(editor.getHtml(), pageName);

      this.htmlEditor.setContent(newCode);
      this.cssEditor.setContent(editor.getCss());

      this.javascriptEditor.setContent('');
      const methodName = 'none';


      const allComps = getAllComponents(editor.DomComponents.getWrapper());
      if (
        JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage].javascript.changeJavascript !== false
      ) {
          Promise.all(
            entitieNames
              .filter( entity => JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage].data.map( data => data.dataName).includes(entity) === true && serviceEntity(entity) === false)
              .map(async(entity) => {
                const functionEntity = await apiService
                .getFrontSDKArtifact(projectId, {
                  fileName: `${entity[0].toUpperCase() + entity.slice(1)}Api.json`
                })
                .then((response) => changeMethodName(response.data, entity))
                .then((renamedMethods) => renamedMethods)
                .catch((err) => {throw err;});
                return { 'entity' : entity, 'func': functionEntity};
              })
            )
            .then( functionEntities => {
              const funcObj = {}
              functionEntities.forEach( func => {
                funcObj[func.entity] = func.func;
              })
              return funcObj;
            })
            .then( async functionEntities => {
           
              Promise.all(
                allComps
                  .filter((comp) => comp.attributes.attributes.id !== undefined)
                  .map(async (comp) => createJavascriptPerComp(comp, methodName, functionEntities))
              )
                .then((responses) => {
                  addFunctionToJavascript(responses, undefined, editor);
                })
                .then(() => {
                  const javascriptFile = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage].javascript.file;
                  this.javascriptEditor.setContent(javascriptFile);
                  setLoadSpinnerCreateJavascript(false);
                })
                .catch((error) => {
                  this.javascriptEditor.setContent('Javascript could not generate correctly');
                  setLoadSpinnerCreateJavascript(false);
                  throw(error);
                });
        })
      } else {
        setLoadSpinnerCreateJavascript(false);
        const javascriptFile = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[
          selectedPage
        ].javascript.file;
        this.javascriptEditor.setContent(javascriptFile);
      }
    },
    stop() {
      const modal = editor.Modal;
      if ( modal ){
        modal.close();
      }
    },

    buildEditor(codeName, theme, label) {
      const input = document.createElement('textarea');
      if ( !this.codeMirror ) {
        this.codeMirror = this.cm.getViewer('CodeMirror');
      }

      const el = this.codeMirror.clone().set({
        label,
        codeName,
        theme,
        input
      });

      const { $el } = new this.cm.EditorView({
        model: el,
        config: this.cm.getConfig()
      }).render();

      el.init(input);

      return { el, $el };
    }
  });
};

export default exportCode;
export {
  convertBodyToHtmlCode,
  convertIdToName,
  recreatePageTransitionCommand,
  createHrefTransitionCommand,
  changeMethodName,
  addFunctionToJavascript,
  createFileEventListener,
  createDatepickerMethod,
  createBackHistoryCommand,
  createServiceFunction,
  findService
};
